module.exports = __webpack_public_path__ + "img/sameday.53839d00.png";